if (!customElements.get('free-shipping-progress')) {
  customElements.define('free-shipping-progress', class FreeShippingProgress extends HTMLElement {
    connectedCallback() {
      this.threshold = Number(this.dataset.threshold);
      this.message = this.querySelector('[data-shipping-message]');
      this.meter = this.querySelector('[data-shipping-meter]');
      this.fill = this.querySelector('[data-shipping-fill]');
      this.requestId = 0;
      this.updateFromData(this.dataset);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => { this.refresh(); });
      }
      this.refresh();
    }

    disconnectedCallback() {
      this.requestId += 1;
      this.unsubscribe?.();
      this.unsubscribe = null;
    }

    async refresh() {
      const requestId = ++this.requestId;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const sectionId = this.closest('.shopify-section')?.id.replace('shopify-section-', '');
        const url = root + 'cart' + (sectionId ? '?section_id=' + encodeURIComponent(sectionId) : '');
        const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } });
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const progress = html.querySelector('free-shipping-progress');
        if (progress && requestId === this.requestId && this.isConnected) {
          this.updateFromData(progress.dataset);
        }
      } catch (_) {
        // Keep the server-rendered state if the cart request is unavailable.
      }
    }

    updateFromData(data) {
      this.update({
        total_price: Number(data.total),
        item_count: Number(data.count),
        currency: data.currency,
        all_discounted: data.allDiscounted === 'true',
      });
    }

    update(cart) {
      if (!this.threshold || !this.message || !this.meter || !this.fill) return;
      const currency = cart.currency || this.dataset.currency;
      const total = Number(cart.total_price) || 0;
      const count = Number(cart.item_count) || 0;
      this.hidden = count === 0 || currency !== 'EUR' || cart.all_discounted === true;
      if (this.hidden) return;

      const remaining = Math.max(0, this.threshold - total);
      const progress = Math.max(0, Math.min(100, Math.round(total * 100 / this.threshold)));
      const locale = document.documentElement.lang || 'lt-LT';
      const formattedRemaining = new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' }).format(remaining / 100);
      this.message.textContent = remaining > 0
        ? 'Iki nemokamo pristatymo paštomatu Lietuvoje trūksta ' + formattedRemaining + '.'
        : 'Pasiekta nemokamo pristatymo paštomatu Lietuvoje riba.';
      this.meter.setAttribute('aria-valuenow', String(progress));
      this.fill.style.width = progress + '%';
    }
  });
}
